// T76 (titipan auditor 27 Okt 2026): kiriman ke alamat WAJIB berkurir + bernomor resi sebelum "Diserahkan".
// Cermin batas server `serah_terima_customer.periksa_kurir_resi` (kurir ≥ 2 huruf, resi ≥ 4 huruf) — layar hanya
// mencegah tombol yang pasti ditolak; penjaganya tetap server.
export function isianKirimLengkap(kurir, resi) {
  const k = String(kurir || "").trim();
  const r = String(resi || "").trim();
  return k.length >= 2 && r.length >= 4;
}

// K237 (BUSINESS-116 b): "Diambil oleh" WAJIB untuk barang yang diambil, terisi otomatis nama customer, diganti bila
// orang lain. Cermin `serah_terima_customer.nama_pengambil` (2–120 huruf). `customerSendiri` = pilihan "customer
// pemesan sendiri" (layar tanpa hak nama customer — server mengisinya dari data customer).
export function isianPengambilLengkap(customerSendiri, nama) {
  if (customerSendiri) return true;
  const n = String(nama || "").trim().replace(/\s+/g, " ");
  return n.length >= 2 && n.length <= 120;
}

// Badan permintaan untuk isian pengambil: null = customer pemesan sendiri (server mengisi nama customer).
export function nilaiPengambil(customerSendiri, nama) {
  if (customerSendiri) return null;
  const n = String(nama || "").trim().replace(/\s+/g, " ");
  return n || null;
}
